import { Directive, HostListener, ElementRef, Renderer2 } from '@angular/core';
import { LocalizationPipe } from '../localization/localization.pipe';

@Directive({
  // eslint-disable-next-line @angular-eslint/directive-selector
  selector: '[PgsInputContratista]'
})
export class PgsInputContratistaDirective {

  regexStr: any;
  regexNum = '[0-9]';
  maxLengthDir: any;

  // constructor() { }
  constructor(private el: ElementRef, private localizationPipe: LocalizationPipe, private renderer: Renderer2) {
  }

  @HostListener('keypress', ['$event']) onKeyPress(event: KeyboardEvent) {

    switch ((event.srcElement as Element).id) {
      case 'vendor-code':
        this.regexStr = this.localizationPipe.transform('INPUT_DIRECTIVE');
        this.maxLengthDir = this.localizationPipe.transform('INPUT_DETAIL_MAX_IDENTIFICATION_LABEL');
        this.renderer.setAttribute(this.el.nativeElement, 'maxLength', this.maxLengthDir);
        return new RegExp(this.regexStr).test(event.key);
      case 'txtnumdoc':
        this.maxLengthDir = this.localizationPipe.transform('INPUT_DETAIL_MAX_NUM_DOC_LABEL');
        this.renderer.setAttribute(this.el.nativeElement, 'maxLength', this.maxLengthDir);
        return new RegExp(this.regexStr).test(event.key);
      case 'searchString':
        this.regexStr = this.localizationPipe.transform('INPUT_DIRECTIVE');
        this.maxLengthDir = this.localizationPipe.transform('INPUT_DETAIL_MAX_IDENTIFICATION_LABEL');
        this.renderer.setAttribute(this.el.nativeElement, 'maxLength', this.maxLengthDir);
        return new RegExp(this.regexStr).test(event.key);
      case 'vendor-identification-number':
        this.regexStr = this.localizationPipe.transform('INPUT_DIRECTIVE');
        this.maxLengthDir = this.localizationPipe.transform('INPUT_DETAIL_MAX_IDENTIFICATION_LABEL');
        this.renderer.setAttribute(this.el.nativeElement, 'maxLength', this.maxLengthDir);
        return new RegExp(this.regexStr).test(event.key);
      case 'document-number':
        this.maxLengthDir = this.localizationPipe.transform('INPUT_DETAIL_MAX_NUM_DOC_LABEL');
        this.renderer.setAttribute(this.el.nativeElement, 'maxLength', this.maxLengthDir);
        return new RegExp(this.regexStr).test(event.key);
      default:
        return new RegExp(this.regexStr).test(event.key);
    }
  }

  @HostListener('paste', ['$event']) blockPaste(event: KeyboardEvent) {
    this.validateFields(event);
  }

  validateFields(event) {
    setTimeout(() => {

      this.el.nativeElement.value = this.el.nativeElement.value.replace(/[^A-Z-@.a-z0-9]/g, '').replace(/\s/g, '');
      event.preventDefault();

    }, 100);
  }
}
